import { useParams, useNavigate } from "react-router-dom";
import { ProductPage as ProductPageView } from "@/components/ProductPage";

export function ProductPage() {
  const { productId } = useParams<{ productId: string }>();
  const navigate = useNavigate();

  if (!productId) return null;

  return (
    <ProductPageView
      productId={productId}
      onBack={() => navigate("/products")}
      onDeleted={() => navigate("/products")}
    />
  );
}
